import React from 'react';
import { cn } from '@/lib/utils';
import { Header } from '../components/Header';
import { Footer } from '../components/ui/Footer';
import { Mail, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
interface ContactMethod {
  href: string;
  external?: boolean;
  icon: React.ReactNode;
  heading: string;
  value: string;
}
const contactMethods: ContactMethod[] = [{
  href: 'https://www.linkedin.com/company/vantage-data-group',
  external: true,
  icon: <Linkedin className="w-12 h-12 text-white" data-id="element-243" />,
  heading: 'Connect on LinkedIn',
  value: 'Vantage Data Group'
}, {
  href: 'mailto:contactus@vantagedatagroup.com',
  icon: <Mail className="w-12 h-12 text-white" data-id="element-244" />,
  heading: 'Email Us',
  value: 'contactus@vantagedatagroup.com',
  isEmail: true
}];
export function ContactPage() {
  return <div className="bg-black min-h-screen" data-id="element-245">
      <Header data-id="element-246" />
      <main className="pt-32 pb-24 px-6" data-id="element-247">
        <div className="max-w-4xl mx-auto" data-id="element-248">
          <motion.div className="text-center mb-16" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-249">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6" data-id="element-250">
              Get In Touch
            </h1>
            <p className="text-xl text-white/80 leading-relaxed" data-id="element-251">
              Ready to transform your healthcare data? Let's talk.
            </p>
          </motion.div>

          <div className="space-y-8" data-id="element-252">
            {contactMethods.map((method, index) => <motion.a key={method.heading} href={method.href} {...method.external ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {}} initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2 + index * 0.15
          }} className="liquid-glass group block rounded-3xl p-12 lg:p-16" whileHover={{
            y: -8,
            scale: 1.02
          }} data-id="element-253">
                <div className="liquid-glass-sheen" aria-hidden="true" data-id="element-254" />
                <div className="relative flex flex-col items-center text-center" data-id="element-255">
                  <motion.div className="liquid-glass-badge w-24 h-24 rounded-full flex items-center justify-center mb-8" whileHover={{
                scale: 1.1,
                rotate: 5
              }} transition={{
                duration: 0.3
              }} data-id="element-256">
                    {method.icon}
                  </motion.div>
                  <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4" data-id="element-257">
                    {method.heading}
                  </h2>
                  <p className={cn(`w-full max-w-full text-white/90 font-medium ${method.isEmail ? 'text-lg leading-snug sm:text-2xl md:text-3xl break-all sm:break-normal' : 'text-2xl md:text-3xl break-words'}`, 'text-[15px]')} data-id="element-258">
                    {method.value}
                  </p>
                </div>
              </motion.a>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-259" />
    </div>;
}